/* unplugin-vue-components disabled */import script from "./data4.vue?vue&type=script&setup=true&lang=js"
export * from "./data4.vue?vue&type=script&setup=true&lang=js"

import "./data4.vue?vue&type=style&index=0&id=50a3ca44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a3ca44"]])

export default __exports__